import * as React from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { metadataTagZonesColorArray } from "../EditIMetadataTagZones/EditMetadataTagZonesUtils/metadataTagZonesColorArray";
import { useNewIgnoreZonesStore } from "./newIgnoreZonesStore/newIgnoreZonesStore";

export const IgnoreZoneConfigPanel = () => {
  const editSession = useNewIgnoreZonesStore((s) => s.editSession);
  const availableMetrics = useNewIgnoreZonesStore((s) => s.availableMetrics);
  const saveValidationError = useNewIgnoreZonesStore((s) => s.saveValidationError);
  const updateEditSessionColor = useNewIgnoreZonesStore(
    (s) => s.updateEditSessionColor
  );
  const updateEditSessionName = useNewIgnoreZonesStore(
    (s) => s.updateEditSessionName
  );
  const setEditSessionIgnoreAll = useNewIgnoreZonesStore(
    (s) => s.setEditSessionIgnoreAll
  );
  const toggleEditSessionMetric = useNewIgnoreZonesStore(
    (s) => s.toggleEditSessionMetric
  );
  const getUsedColors = useNewIgnoreZonesStore((s) => s.getUsedColors);

  if (!editSession) {
    return null;
  }

  const usedColors = getUsedColors(editSession.localId);

  const checkboxSx = {
    color: "#001943",
    "&.Mui-checked": { color: editSession.color },
  };

  const formControlLabelSx = {
    marginLeft: 0,
    marginRight: 0,
    "& .MuiFormControlLabel-label": {
      fontFamily: "Mulish",
      color: "#001943",
    },
  };

  return (
    <div className="font-mulish text-actuate-blue min-w-[420px] pr-[40px]">
      <p className="font-bold text-[17px] mb-[16px]">Ignore Zone Configuration</p>

      <p className="text-[15px] font-semibold mb-[8px]">Name</p>
      <TextField
        value={editSession.name ?? ""}
        variant="standard"
        fullWidth
        placeholder="Zone name"
        onChange={(event) => updateEditSessionName(event.target.value)}
        sx={{
          mb: "24px",
          fontFamily: "Mulish",
          "& .MuiInputBase-input": { fontFamily: "Mulish", color: "#001943" },
          "& .MuiInput-underline:before": { borderBottomColor: "#001943" },
          "& .MuiInput-underline:after": { borderBottomColor: "#001943" },
        }}
      />

      <p className="text-[15px] font-semibold mb-[8px]">Color</p>
      <div className="grid grid-cols-8 gap-[8px] mb-[24px] w-fit">
        {metadataTagZonesColorArray.map((color) => {
          const isUsed = usedColors.includes(color);
          const isSelected = editSession.color === color;
          return (
            <button
              key={color}
              type="button"
              aria-label={`Select color ${color}`}
              disabled={isUsed && !isSelected}
              onClick={() => updateEditSessionColor(color)}
              style={{
                width: 28,
                height: 28,
                backgroundColor: color,
                border: isSelected ? "3px solid #001943" : "1px solid #001943",
                opacity: isUsed && !isSelected ? 0.35 : 1,
                cursor: isUsed && !isSelected ? "not-allowed" : "pointer",
              }}
            />
          );
        })}
      </div>

      <p className="text-[15px] font-semibold mb-[8px]">Products</p>
      <FormGroup sx={{ gap: 0, alignItems: "flex-start" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={editSession.isIgnoreAll}
              onChange={(event) => setEditSessionIgnoreAll(event.target.checked)}
              sx={checkboxSx}
            />
          }
          label="Select All"
          sx={formControlLabelSx}
        />
        <div className="ml-[20px] flex flex-col">
          {availableMetrics.map((metric) => (
            <FormControlLabel
              key={metric.metricId}
              control={
                <Checkbox
                  checked={editSession.metricIds.includes(metric.metricId)}
                  onChange={(event) =>
                    toggleEditSessionMetric(metric.metricId, event.target.checked)
                  }
                  sx={checkboxSx}
                />
              }
              label={metric.labelDisplayName}
              sx={formControlLabelSx}
            />
          ))}
        </div>
      </FormGroup>

      {saveValidationError && (
        <p className="text-[14px] text-red-600 mt-[16px]">{saveValidationError}</p>
      )}
    </div>
  );
};
